import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="internacion-autocomplete"
export default class extends Controller {
  static targets = ["queryInput", "registroHidden", "selectedRegistro", "results"]
  static values = {
    url: String
  }

  connect() {
    this.searchTimeout = null
  }

  search() {
    const query = this.queryInputTarget.value.trim()

    this.registroHiddenTarget.value = ""
    this.selectedRegistroTarget.value = ""

    clearTimeout(this.searchTimeout)

    if (query.length < 2) {
      this.renderResults([])
      return
    }

    this.searchTimeout = setTimeout(async () => {
      try {
        const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
          headers: { Accept: "application/json" }
        })

        if (!response.ok) {
          this.renderResults([])
          return
        }

        const internaciones = await response.json()
        this.renderResults(internaciones)
      } catch (error) {
        this.renderResults([])
      }
    }, 250)
  }

  select(event) {
    const item = event.currentTarget
    const registro = item.dataset.registro
    const label = item.dataset.label

    this.registroHiddenTarget.value = registro
    this.selectedRegistroTarget.value = registro
    this.queryInputTarget.value = label
    this.renderResults([])
  }

  renderResults(items) {
    this.resultsTarget.innerHTML = ""

    if (!items.length) {
      return
    }

    items.forEach((item) => {
      const li = document.createElement("li")
      li.className = "list-group-item list-group-item-action py-2 px-2"
      li.setAttribute("role", "option")
      li.textContent = item.label
      li.dataset.registro = item.registro
      li.dataset.label = item.label
      li.addEventListener("click", (event) => this.select(event))
      this.resultsTarget.appendChild(li)
    })
  }
}
